import { render, staticRenderFns } from "./ddinglogin.vue?vue&type=template&id=01479c56&scoped=true&"
import script from "./ddinglogin.vue?vue&type=script&lang=js&"
export * from "./ddinglogin.vue?vue&type=script&lang=js&"
import style0 from "./ddinglogin.vue?vue&type=style&index=0&id=01479c56&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01479c56",
  null
  
)

export default component.exports